import type { FCWithChildren } from '@pbk-web/types';
import type { RefObject } from 'react';
import { createContext, useContext, useRef } from 'react';

type LayoutContextType = {
  leftNavRef: RefObject<HTMLDivElement | null>;
};

export const LayoutContext = createContext<LayoutContextType>(null!);
export const useLayout = (): LayoutContextType => useContext(LayoutContext);
export const LayoutProvider: FCWithChildren = (props) => {
  const { children } = props;
  const leftNavRef = useRef<HTMLDivElement | null>(null);
  return <LayoutContext.Provider value={{ leftNavRef: leftNavRef }}>{children}</LayoutContext.Provider>;
};
